<template>
  <l-marker
    :key="marker.id"
    :lat-lng="coords"
    :options="markerOptions"
    ref="marker"
    @click="selectStore"
  >
    <l-icon :icon-anchor="[17.5, 1]">
      <div class="icon-label-flex">
        <img :class="imageMarker === 'hublot' ? 'enseigne-hublot' : 'enseigne-icon'" :src="`/images/markers/${imageMarker}.png`" :alt="marker.enseigne" draggable="false"/>
      </div>
    </l-icon>
    <l-popup ref="popup" v-if="imageMarker !== 'hublot'" :options="popupOptions">
      <div class="store-popup">
        <div class="popup-header">
          <img :src="`/images/${imageMarker}.png`" class="popup-logo" :alt="marker.enseigne"/>
          <div class="popup-title-group">
            <h3 class="popup-title">{{marker.name}}</h3>
            <p class="popup-enseigne">{{marker.enseigne}}</p>
          </div>
        </div>
        
        <div class="popup-divider"></div>
        
        <div class="popup-info" v-if="marker.address">
          <v-icon small color="primary" class="info-icon">mdi-map-marker</v-icon>
          <span class="info-text">{{marker.address}}</span>
        </div>
        
        <div class="popup-info">
          <v-icon small color="primary" class="info-icon">mdi-crosshairs-gps</v-icon>
          <a 
            :href="`https://www.google.com/maps/search/?api=1&query=${marker.latitude},${marker.longitude}`" 
            target="_blank" 
            class="coordinates-link"
          >
            {{marker.latitude}}, {{marker.longitude}}
          </a>
        </div>
        
        <div class="popup-info" v-if="marker.phone">
          <v-icon small color="primary" class="info-icon">mdi-phone</v-icon>
          <span class="info-text">{{marker.phone}}</span>
        </div>
      </div>
    </l-popup>
  </l-marker>
</template>

<script>
import { LIcon, LMarker, LPopup } from 'vue2-leaflet'
import { mapState } from 'vuex'
import L from 'leaflet'

// Désactiver les ombres des markers pour éviter les erreurs
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: ''
})
export default {
  components: { LIcon, LMarker, LPopup },
  props: {
    marker: {
      type: Object,
      required: true
    },
    zoomCurrent: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      // storeId permet à la carte de retrouver ce marqueur pour ouvrir son
      // popup à la fin du vol
      markerOptions: {
        storeId: this.marker.id,
        riseOnHover: true
      },
      popupOptions: {
        minWidth: this.isMobile() ? 260 : 280,
        maxWidth: this.isMobile() ? 300 : 320,
        className: 'custom-popup',
        // Un tap dans le vide ne doit pas déclencher un retour vue France
        closeOnClick: false,
        // Le recadrage est fait par le flyTo de la carte : un autoPan
        // concurrent ferait sauter l'animation
        autoPan: false
      }
    }
  },
  mounted(){
    // Update popup options on resize
    window.addEventListener('resize', this.updatePopupOptions)
    // La croix du popup est la sortie visible sur mobile
    const mapObject = this.$refs.marker && this.$refs.marker.mapObject
    if (mapObject) {
      mapObject.on('popupclose', this.onPopupClose)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updatePopupOptions)
    const mapObject = this.$refs.marker && this.$refs.marker.mapObject
    if (mapObject) {
      mapObject.off('popupclose', this.onPopupClose)
    }
  },
  computed:{
    ...mapState({
      selectedEnseigne: state => state.enseignes.current,
    }),
      coords() {
          return {lat: Number(this.marker.latitude), lng: Number(this.marker.longitude)}
      },
      imageMarker() {
          if (this.marker.enseigne.includes('Intermarché')) {
            return 'intermarche'
          } else if (this.marker.enseigne.includes('E.Leclerc')) {
        return 'leclerc'

          } else if (this.marker.enseigne.includes('Super U')) {
              return 'superu'
      }else if (this.marker.enseigne.includes('Indépendant')) {
              return 'independant'
      }else if (this.marker.enseigne.includes('Carrefour')) {
              return 'carrefour'
      }else if (this.marker.enseigne.includes('Hublot')) {
              return 'hublot'
      }
      return ''
      }

  },
    watch: {
      selectedEnseigne(newVal, oldVal) {
        // Si le magasin sélectionné n'est plus ce marker, fermer le popup
        if (oldVal && oldVal.id === this.marker.id && (!newVal || newVal.id !== this.marker.id)) {
          this.closePopup()
        }
      }
    },
  methods: {
    closePopup() {
      if (this.$refs.marker && this.$refs.marker.mapObject) {
        this.$refs.marker.mapObject.closePopup()
      }
    },
    selectStore() {
      // Re-taper le magasin déjà sélectionné le relâche
      if (this.selectedEnseigne && this.selectedEnseigne.id === this.marker.id) {
        this.deselectStore()
        return
      }
      this.$store.dispatch('setCurrentEnseigne', this.marker)
    },
    deselectStore() {
      this.$store.dispatch('deselectEnseigne')
    },
    onPopupClose() {
      // Ouvrir un autre popup ferme celui-ci : ne relâcher que si ce marqueur
      // est encore le magasin courant
      if (this.selectedEnseigne && this.selectedEnseigne.id === this.marker.id) {
        this.deselectStore()
      }
    },
    isMobile() {
      return window.innerWidth <= 960
    },
    updatePopupOptions() {
      this.popupOptions.minWidth = this.isMobile() ? 260 : 280
      this.popupOptions.maxWidth = this.isMobile() ? 300 : 320
    }
  }
}

</script>

<style>
  .enseigne-icon {
    width: 35px;
    height: 35px;
    max-width: 35px;
    max-height: 35px;
    min-width: 24px;
    min-height: 24px;
    transition: transform 0.18s cubic-bezier(0.2, 0.8, 0.2, 1);
    will-change: transform;
  }
  
  @media (hover: hover) {
    .enseigne-icon:hover {
      transform: scale(1.15);
    }
  }
  
  .enseigne-hublot {
    width: 60px;
    height: 60px;
    max-width: 60px;
    max-height: 60px;
    min-width: 40px;
    min-height: 40px;
  }
  
  /* Custom Popup Styles */
  .store-popup {
    font-family: 'Roboto', sans-serif;
    padding: 4px;
  }
  
  .popup-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }
  
  .popup-logo {
    width: 40px;
    height: 40px;
    object-fit: contain;
    flex-shrink: 0;
  }
  
  .popup-title-group {
    flex: 1;
  }
  
  .popup-title {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
    line-height: 1.3;
  }
  
  .popup-enseigne {
    margin: 4px 0 0 0;
    font-size: 13px;
    color: #666;
    font-weight: 500;
  }
  
  .popup-divider {
    height: 1px;
    background: linear-gradient(to right, #e0e0e0, transparent);
    margin: 12px 0;
  }
  
  .popup-info {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin: 8px 0;
    font-size: 13px;
    color: #424242;
  }
  
  .info-icon {
    margin-top: 2px;
  }
  
  .info-text {
    flex: 1;
    line-height: 1.4;
  }
  
  .coordinates-link {
    flex: 1;
    line-height: 1.4;
    color: #1976d2;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.2s ease;
  }
  
  .coordinates-link:hover {
    color: #1565c0;
    text-decoration: underline;
  }
  
  .marker-label {
    margin-left: 6px;
    font-size: 11px;
    color: #b0b0b0;
    background: rgba(255,255,255,0.6);
    border-radius: 4px;
    padding: 1px 6px;
    font-weight: 400;
    box-shadow: none;
    pointer-events: none;
    user-select: none;
    max-width: 90px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    top: -14px;
    z-index: 2;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .marker-label-centered {
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    top: 50%;
    margin-left: 0;
    background: rgba(255,255,255,0.85);
    color: #333;
    font-weight: 500;
    font-size: 12px;
    padding: 2px 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    border-radius: 8px;
    min-width: 60px;
    max-width: 120px;
    text-align: center;
    white-space: nowrap;
  }
  .marker-label-below {
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translateX(-50%) translateY(6px);
    background: rgba(255,255,255,0.85);
    color: #333;
    font-weight: 500;
    font-size: 12px;
    padding: 2px 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    border-radius: 8px;
    min-width: 60px;
    max-width: 120px;
    text-align: center;
    white-space: nowrap;
    z-index: 3;
    pointer-events: none;
  }
  .icon-label-flex {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    gap: 2px;
  }
  .marker-label-inline {
    margin-top: 6px;
    background: rgba(255,255,255,0.95);
    color: #333;
    font-weight: 500;
    font-size: 12px;
    padding: 2px 16px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    border-radius: 8px;
    text-align: center;
    white-space: normal;
    line-height: 1.2;
    display: inline-block;
    margin-left: auto;
    margin-right: auto;
    overflow-wrap: break-word;
    word-break: break-word;
    width: auto;
  }
  .marker-label-inline.marker-label-below {
    margin-top: 0;
    position: static;
    text-align: center;
    width: 100%;
    left: 0;
    transform: none;
  }
  
  /* Override Leaflet popup styles */
  ::v-deep .custom-popup .leaflet-popup-content-wrapper {
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }
  
  ::v-deep .custom-popup .leaflet-popup-content {
    margin: 0;
    min-width: 280px;
  }
  
  ::v-deep .custom-popup .leaflet-popup-tip {
    top: -16px !important;
    left: 24px !important;
    background: white;
  }
  
  /* Mobile Responsive Styles */
  @media (max-width: 600px) {
    .popup-header {
      gap: 8px;
    }
    
    .popup-logo {
      width: 32px;
      height: 32px;
    }
    
    .popup-title {
      font-size: 14px;
    }
    
    .popup-enseigne {
      font-size: 12px;
    }
    
    .popup-info {
      font-size: 12px;
      margin: 6px 0;
    }
    
    ::v-deep .custom-popup .leaflet-popup-content-wrapper {
      border-radius: 10px;
      padding: 10px;
    }
    
    ::v-deep .custom-popup .leaflet-popup-content {
      min-width: 240px !important;
    }
  }
</style>
